import { ChevronRight } from "lucide-react";
import type { ReactNode } from "react";

/**
 * The first cell of a row in the tree: its indent, its disclosure, the mark of
 * what kind of thing the row is, and its label. A row with nothing under it
 * keeps the disclosure's width, so the titles of one level start on one line.
 */
export function TreeNode({
	depth,
	open,
	onToggle,
	label,
	icon,
	children,
}: {
	depth: 0 | 1 | 2;
	open?: boolean;
	onToggle?: () => void;
	label?: string;
	icon: ReactNode;
	children: ReactNode;
}) {
	return (
		<div className="tree-node" data-depth={depth}>
			{onToggle ? (
				<button type="button" className="tree-toggle" aria-expanded={open} aria-label={label} onClick={onToggle}>
					<ChevronRight aria-hidden="true" />
				</button>
			) : (
				<span className="tree-toggle" aria-hidden="true" />
			)}
			<span className="tree-icon">{icon}</span>
			<div className="tree-body">{children}</div>
		</div>
	);
}
